import { atom } from "recoil";
import { IEmailDomain } from "../types";

export const addStateEmailDomain = atom({
  key: "addStateEmailDomain",
  default: false,
});
export const editStateEmailDomain = atom({
  key: "editStateEmailDomain",
  default: false,
});
export const rowEditEmailDomain = atom<IEmailDomain | undefined>({
  key: "rowEditemailDomain",
  default: undefined,
});

export const selectedRowsStateEmailDomain = atom<IEmailDomain[]>({
  key: "selectedRowsStateEmailDomain",
  default: [],
});

export const emailDomainFilterText = atom({
  key: "emailDomainFilterText",
  default: "",
});

export const emailDomainFetching = atom({
  key: "emailDomainFetching",
  default: true,
});
export const emailDomainReFetching = atom({
  key: "emailDomainReFetching",
  default: false,
});
